(function () {
  'use strict';

  var root = document.getElementById('eros-reviews');
  if (!root) return;

  var handle = root.dataset.productHandle;
  var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
  if (!handle || !apiBase) return;

  var aggEl = root.querySelector('.eros-reviews__aggregate');
  var listEl = root.querySelector('.eros-reviews__list');
  var form = document.getElementById('eros-reviews-form');
  var starsEl = document.getElementById('eros-reviews-stars');
  var bodyEl = document.getElementById('eros-reviews-body');
  var loginGate = document.getElementById('eros-reviews-login-gate');
  var formMsg = document.getElementById('eros-reviews-form-msg');
  var locale = root.dataset.locale || 'ar';
  var cursor = null;
  var loading = false;
  var started = false;
  var initialPageSize = 2;
  var loadMorePageSize = 20;
  var totalReviewCount = 0;
  var selectedRating = 5;
  var customerLoggedIn = root.dataset.customerLoggedIn === '1';
  var customerGid = root.dataset.customerGid || '';
  var customerName = root.dataset.customerName || '';
  var reviewsSecret = root.dataset.reviewsSecret || '';
  var loginUrl = root.dataset.loginUrl || '/account/login';
  var replyLabel = root.dataset.replyLabel || 'رد';
  var replySubmitLabel = root.dataset.replySubmitLabel || 'إرسال';
  var photoInput = document.getElementById('eros-reviews-photo');
  var photoNameEl = document.getElementById('eros-reviews-photo-name');
  var pendingPhotoFile = null;
  var listSortBy = 'created_at';
  var listSortOrder = 'desc';
  var ratingOffset = 0;

  function photoHtml(url, alt) {
    if (!url) return '';
    return (
      '<button type="button" class="eros-reviews__photo-thumb-btn" data-action="zoom-photo" data-src="' +
      escapeHtml(url) +
      '"><img class="eros-reviews__photo eros-reviews__photo--thumb" src="' +
      escapeHtml(url) +
      '" alt="' +
      escapeHtml(alt || '') +
      '" loading="lazy" /></button>'
    );
  }

  function ensureLightbox() {
    if (document.getElementById('eros-reviews-lightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'eros-reviews-lightbox';
    lb.className = 'eros-reviews__lightbox hidden';
    lb.innerHTML =
      '<button type="button" class="eros-reviews__lightbox-close" data-action="close-lightbox" aria-label="إغلاق">×</button>' +
      '<img class="eros-reviews__lightbox-img" src="" alt="" />';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (ev) {
      if (
        ev.target === lb ||
        ev.target.closest('[data-action="close-lightbox"]')
      ) {
        lb.classList.add('hidden');
        lb.querySelector('img').src = '';
      }
    });
  }

  function openPhotoLightbox(url) {
    ensureLightbox();
    var lb = document.getElementById('eros-reviews-lightbox');
    var img = lb.querySelector('img');
    img.src = url;
    lb.classList.remove('hidden');
  }

  function ensureSortBar() {
    if (root.querySelector('.eros-reviews__sort-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'eros-reviews__sort-bar';
    bar.innerHTML =
      '<label class="eros-reviews__sort-label">ترتيب' +
      '<select id="eros-reviews-sort-by" class="eros-reviews__sort-select">' +
      '<option value="created_at|desc">الأحدث</option>' +
      '<option value="created_at|asc">الأقدم</option>' +
      '<option value="rating|desc">الأعلى تقييماً</option>' +
      '<option value="rating|asc">الأقل تقييماً</option>' +
      '</select></label>';
    var list = root.querySelector('.eros-reviews__list');
    if (list) list.before(bar);
    bar.querySelector('select').addEventListener('change', function (ev) {
      var parts = String(ev.target.value || 'created_at|desc').split('|');
      listSortBy = parts[0] || 'created_at';
      listSortOrder = parts[1] || 'desc';
      cursor = null;
      ratingOffset = 0;
      loadReviews(false);
    });
  }

  function stars(n) {
    var max = 5;
    var out = '';
    for (var i = 0; i < max; i++) {
      out += i < n ? '★' : '☆';
    }
    return '<span class="eros-reviews__stars" aria-hidden="true">' + out + '</span>';
  }

  function buildStarInput() {
    if (!starsEl) return;
    starsEl.innerHTML = '';
    for (var i = 1; i <= 5; i++) {
      (function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'eros-reviews__star-btn' + (value <= selectedRating ? ' is-active' : '');
        btn.setAttribute('aria-label', value + '/5');
        btn.setAttribute('aria-pressed', value <= selectedRating ? 'true' : 'false');
        btn.textContent = '★';
        btn.addEventListener('click', function () {
          selectedRating = value;
          buildStarInput();
        });
        starsEl.appendChild(btn);
      })(i);
    }
  }

  function setFormMsg(text, isError) {
    if (!formMsg) return;
    formMsg.textContent = text || '';
    formMsg.classList.toggle('is-error', !!isError);
  }

  function showLoginGate() {
    if (loginGate) loginGate.hidden = false;
    setFormMsg('', false);
  }

  function hideLoginGate() {
    if (loginGate) loginGate.hidden = true;
  }

  function initials(name) {
    var parts = String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return String(name || '?')
      .trim()
      .slice(0, 2)
      .toUpperCase();
  }

  function fmtRelative(ms) {
    var diff = Date.now() - ms;
    var sec = Math.floor(diff / 1000);
    if (sec < 60) return 'الآن';
    var min = Math.floor(sec / 60);
    if (min < 60) return min + ' د';
    var hr = Math.floor(min / 60);
    if (hr < 24) return hr + ' س';
    var day = Math.floor(hr / 24);
    if (day < 7) return day + ' ي';
    try {
      return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(new Date(ms));
    } catch (e) {
      return '';
    }
  }

  function replyFormHtml(reviewId, parentReplyId) {
    var parentAttr = parentReplyId
      ? ' data-parent-reply-id="' + escapeHtml(parentReplyId) + '"'
      : '';
    return (
      '<form class="eros-reviews__reply-form" data-action="reply-form" data-review-id="' +
      escapeHtml(reviewId) +
      '"' +
      parentAttr +
      ' hidden novalidate>' +
      '<div class="eros-reviews__composer eros-reviews__composer--reply">' +
      '<textarea class="eros-reviews__textarea" rows="1" placeholder="' +
      escapeHtml(replyLabel) +
      '…" aria-label="' +
      escapeHtml(replyLabel) +
      '"></textarea>' +
      '<input type="file" class="eros-reviews__reply-photo-input" accept="image/jpeg,image/png,image/webp" hidden />' +
      '<button type="button" class="eros-reviews__composer-photo" data-action="pick-reply-photo" aria-label="إرفاق صورة">+</button>' +
      '<button type="submit" class="eros-reviews__composer-send">' +
      escapeHtml(replySubmitLabel) +
      '</button></div>' +
      '<p class="eros-reviews__reply-msg" aria-live="polite"></p></form>'
    );
  }

  function replyNodeHtml(reply, reviewId) {
    var nested = (reply.replies || [])
      .map(function (child) {
        return replyNodeHtml(child, reviewId);
      })
      .join('');
    var nestedBlock = nested ? '<div class="eros-reviews__replies">' + nested + '</div>' : '';
    return (
      '<div class="eros-reviews__reply" data-reply-id="' +
      escapeHtml(reply.id) +
      '">' +
      '<div class="eros-reviews__avatar" aria-hidden="true">' +
      escapeHtml(initials(reply.authorDisplayName)) +
      '</div>' +
      '<div class="eros-reviews__comment-main">' +
      '<p class="eros-reviews__comment-line"><strong>' +
      escapeHtml(reply.authorDisplayName) +
      '</strong>' +
      escapeHtml(reply.body) +
      '</p>' +
      (reply.imageUrl ? photoHtml(reply.imageUrl, reply.authorDisplayName) : '') +
      '<div class="eros-reviews__comment-meta">' +
      '<time datetime="' +
      reply.createdAt +
      '">' +
      fmtRelative(reply.createdAt) +
      '</time>' +
      '<button type="button" class="eros-reviews__meta-btn" data-action="toggle-reply">' +
      escapeHtml(replyLabel) +
      '</button></div>' +
      replyFormHtml(reviewId, reply.id) +
      nestedBlock +
      '</div></div>'
    );
  }

  function card(review) {
    var img = review.imageUrl ? photoHtml(review.imageUrl, review.authorDisplayName) : '';
    var bodyText = String(review.body || '').trim();
    var bodyHtml = bodyText.length
      ? escapeHtml(bodyText)
      : '';
    var replies = review.replies || [];
    var repliesHtml = '';
    if (replies.length) {
      repliesHtml =
        '<div class="eros-reviews__replies">' +
        replies.map(function (r) {
          return replyNodeHtml(r, review.id);
        }).join('') +
        '</div>';
    }
    return (
      '<article class="eros-reviews__thread" data-review-id="' +
      escapeHtml(review.id) +
      '">' +
      '<div class="eros-reviews__comment">' +
      '<div class="eros-reviews__avatar" aria-hidden="true">' +
      escapeHtml(initials(review.authorDisplayName)) +
      '</div>' +
      '<div class="eros-reviews__comment-main">' +
      '<p class="eros-reviews__comment-line"><strong>' +
      escapeHtml(review.authorDisplayName) +
      '</strong>' +
      bodyHtml +
      '</p>' +
      '<div class="eros-reviews__comment-rating">' +
      stars(review.rating) +
      '</div>' +
      img +
      '<div class="eros-reviews__comment-meta">' +
      '<time datetime="' +
      review.createdAt +
      '">' +
      fmtRelative(review.createdAt) +
      '</time>' +
      '<button type="button" class="eros-reviews__meta-btn" data-action="toggle-reply">' +
      escapeHtml(replyLabel) +
      '</button></div>' +
      repliesHtml +
      replyFormHtml(review.id, '') +
      '</div></div></article>'
    );
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function uploadReplyPhoto(reviewId, replyId, file) {
    var fd = new FormData();
    fd.append('file', file);
    var headers = { Accept: 'application/json' };
    if (reviewsSecret.length) headers['X-Eros-Reviews-Secret'] = reviewsSecret;
    if (customerGid.length) headers['X-Customer-Gid'] = customerGid;
    return fetch(
      apiBase + '/api/v1/reviews/' + encodeURIComponent(reviewId) + '/replies/' + encodeURIComponent(replyId) + '/image',
      {
        method: 'POST',
        credentials: 'omit',
        headers: headers,
        body: fd,
      },
    ).then(function (res) {
      if (!res.ok) throw new Error('photo_upload_failed');
      return res.json();
    });
  }

  function uploadReviewPhoto(reviewId, file) {
    var fd = new FormData();
    fd.append('file', file);
    var headers = { Accept: 'application/json' };
    if (reviewsSecret.length) headers['X-Eros-Reviews-Secret'] = reviewsSecret;
    if (customerGid.length) headers['X-Customer-Gid'] = customerGid;
    return fetch(apiBase + '/api/v1/reviews/' + encodeURIComponent(reviewId) + '/image', {
      method: 'POST',
      credentials: 'omit',
      headers: headers,
      body: fd,
    }).then(function (res) {
      if (!res.ok) throw new Error('photo_upload_failed');
      return res.json();
    });
  }

  function clearPendingPhoto() {
    pendingPhotoFile = null;
    if (photoInput) photoInput.value = '';
    if (photoNameEl) {
      photoNameEl.textContent = '';
      photoNameEl.hidden = true;
    }
  }

  function fetchJson(path, options) {
    return fetch(apiBase + path, options || { credentials: 'omit' }).then(function (res) {
      if (!res.ok) {
        return res
          .json()
          .catch(function () {
            throw new Error('http_' + res.status);
          })
          .then(function (data) {
            var err = new Error(data.error || 'http_' + res.status);
            err.status = res.status;
            err.payload = data;
            throw err;
          });
      }
      return res.json();
    });
  }

  function renderAggregate(agg) {
    if (!aggEl) return;
    totalReviewCount = agg && agg.reviewCount ? agg.reviewCount : 0;
    if (!agg || !agg.reviewCount) {
      aggEl.textContent = '';
      return;
    }
    aggEl.innerHTML =
      stars(Math.round(agg.averageRating)) +
      ' <strong>' +
      agg.averageRating.toFixed(1) +
      '</strong> / 5 (' +
      agg.reviewCount +
      ')';
  }

  function loadReviews(append) {
    if (loading || !listEl) return;
    loading = true;
    var pageLimit = append ? loadMorePageSize : initialPageSize;
    var q = '?limit=' + pageLimit + '&sortBy=' + encodeURIComponent(listSortBy) + '&sortOrder=' + encodeURIComponent(listSortOrder);
    if (listSortBy === 'rating') {
      if (append && ratingOffset) q += '&offset=' + encodeURIComponent(String(ratingOffset));
    } else if (cursor) {
      q += '&cursor=' + encodeURIComponent(String(cursor));
    }
    fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/reviews' + q)
      .then(function (data) {
        var items = data.items || [];
        if (!append) listEl.innerHTML = '';
        if (!items.length && !append) {
          listEl.innerHTML = '<p class="eros-reviews__empty">لا توجد تقييمات بعد.</p>';
        } else {
          listEl.insertAdjacentHTML('beforeend', items.map(card).join(''));
        }
        cursor = data.nextCursor || null;
        if (listSortBy === 'rating' && data.offset != null) ratingOffset = data.offset;
        listEl.setAttribute('aria-busy', 'false');
        maybeAddLoadMore();
      })
      .catch(function () {
        listEl.innerHTML = '<p class="eros-reviews__empty">تعذّر تحميل التقييمات.</p>';
        listEl.setAttribute('aria-busy', 'false');
      })
      .finally(function () {
        loading = false;
      });
  }

  function maybeAddLoadMore() {
    var btn = root.querySelector('.eros-reviews__load-more');
    if (btn) btn.remove();
    var displayed = listEl.querySelectorAll('.eros-reviews__thread').length;
    if (totalReviewCount <= initialPageSize || displayed >= totalReviewCount) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eros-reviews__load-more';
    btn.textContent = 'عرض المزيد من التعليقات';
    btn.addEventListener('click', function () {
      loadReviews(true);
    });
    listEl.after(btn);
  }

  function submitReply(reviewId, replyForm) {
    var textarea = replyForm.querySelector('textarea');
    var msgEl = replyForm.querySelector('.eros-reviews__reply-msg');
    var submitBtn = replyForm.querySelector('button[type="submit"]');
    var photoInput = replyForm.querySelector('.eros-reviews__reply-photo-input');
    var pendingReplyPhoto =
      photoInput && photoInput.files && photoInput.files[0] ? photoInput.files[0] : null;
    var text = (textarea && textarea.value ? textarea.value : '').trim();

    function setReplyMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.classList.toggle('is-error', !!isError);
    }

    setReplyMsg('', false);
    if (!text.length) {
      setReplyMsg('اكتبي نص الرد.', true);
      return;
    }

    if (!customerLoggedIn || !customerGid) {
      showLoginGate();
      return;
    }

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (reviewsSecret.length) headers['X-Eros-Reviews-Secret'] = reviewsSecret;
    if (submitBtn) submitBtn.disabled = true;

    var payload = {
      body: text,
      locale: locale,
      customerGid: customerGid,
      authorDisplayName: customerName,
    };
    var parentReplyId = replyForm.getAttribute('data-parent-reply-id');
    if (parentReplyId) payload.parentReplyId = parentReplyId;

    fetchJson(
      '/api/v1/theme/products/' +
        encodeURIComponent(handle) +
        '/reviews/' +
        encodeURIComponent(reviewId) +
        '/replies',
      {
        method: 'POST',
        credentials: 'omit',
        headers: headers,
        body: JSON.stringify(payload),
      },
    )
      .then(function (data) {
        var replyId = data.reply && data.reply.id;
        var chain = Promise.resolve();
        if (pendingReplyPhoto && replyId) {
          chain = uploadReplyPhoto(reviewId, replyId, pendingReplyPhoto).catch(function () {
            return { photoFailed: true };
          });
        }
        return chain.then(function () {
          if (textarea) textarea.value = '';
          if (photoInput) photoInput.value = '';
          replyForm.hidden = true;
          setReplyMsg('', false);
          if (data.status === 'approved') {
            setFormMsg('', false);
            cursor = null;
            ratingOffset = 0;
            loadReviews(false);
            return fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate');
          }
          setFormMsg('تم إرسال ردك — سيُراجع قبل النشر.', false);
        });
      })
      .catch(function (err) {
        if (err.status === 401 || (err.payload && err.payload.error === 'login_required')) {
          showLoginGate();
          return;
        }
        if (err.payload && err.payload.error === 'rate_limited') {
          setReplyMsg('محاولات كثيرة — حاولي لاحقاً.', true);
          return;
        }
        setReplyMsg('تعذّر إرسال الرد.', true);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function onListClick(ev) {
    var zoom = ev.target.closest('[data-action="zoom-photo"]');
    if (zoom) {
      openPhotoLightbox(zoom.getAttribute('data-src'));
      return;
    }
    var pickPhoto = ev.target.closest('[data-action="pick-reply-photo"]');
    if (pickPhoto) {
      var form = pickPhoto.closest('.eros-reviews__reply-form');
      var input = form && form.querySelector('.eros-reviews__reply-photo-input');
      if (input) input.click();
      return;
    }
    var toggle = ev.target.closest('[data-action="toggle-reply"]');
    if (!toggle) return;
    var host = toggle.closest('.eros-reviews__comment-main');
    if (!host) return;
    var replyForm = host.querySelector(':scope > .eros-reviews__reply-form[data-action="reply-form"]');
    if (!replyForm) return;

    var thread = toggle.closest('.eros-reviews__thread');
    if (thread) {
      thread.querySelectorAll('.eros-reviews__reply-form').forEach(function (f) {
        if (f !== replyForm) f.hidden = true;
      });
    }

    replyForm.hidden = !replyForm.hidden;
    if (!replyForm.hidden) {
      var ta = replyForm.querySelector('textarea');
      if (ta) ta.focus();
    }
  }

  function onListSubmit(ev) {
    var replyForm = ev.target.closest('[data-action="reply-form"]');
    if (!replyForm) return;
    ev.preventDefault();
    var reviewId = replyForm.getAttribute('data-review-id');
    if (!reviewId) return;
    submitReply(reviewId, replyForm);
  }

  function submitReview(ev) {
    ev.preventDefault();
    hideLoginGate();
    setFormMsg('', false);

    var text = (bodyEl && bodyEl.value ? bodyEl.value : '').trim();
    if (selectedRating < 1) {
      setFormMsg('اختاري تقييماً بالنجوم.', true);
      return;
    }

    if (!customerLoggedIn || !customerGid) {
      showLoginGate();
      return;
    }

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (reviewsSecret.length) headers['X-Eros-Reviews-Secret'] = reviewsSecret;

    var submitBtn = form && form.querySelector('.eros-reviews__composer-send');
    if (submitBtn) submitBtn.disabled = true;

    fetchJson('/api/v1/theme/products/' + encodeURIComponent(handle) + '/reviews', {
      method: 'POST',
      credentials: 'omit',
      headers: headers,
      body: JSON.stringify({
        body: text,
        rating: selectedRating,
        locale: locale,
        customerGid: customerGid,
        authorDisplayName: customerName,
      }),
    })
      .then(function (data) {
        var reviewId = data.review && data.review.id;
        var chain = Promise.resolve();
        if (pendingPhotoFile && reviewId) {
          chain = uploadReviewPhoto(reviewId, pendingPhotoFile).then(
            function () {
              return { photoFailed: false };
            },
            function () {
              return { photoFailed: true };
            },
          );
        }
        return chain.then(function (photoResult) {
          if (bodyEl) bodyEl.value = '';
          clearPendingPhoto();
          selectedRating = 5;
          buildStarInput();
          cursor = null;
          ratingOffset = 0;
          if (data.status === 'approved') {
            if (photoResult && photoResult.photoFailed) {
              setFormMsg('تم نشر التقييم — تعذّر رفع الصورة.', false);
            } else {
              setFormMsg('', false);
            }
          } else if (photoResult && photoResult.photoFailed) {
            setFormMsg('تم إرسال التقييم — تعذّر رفع الصورة.', false);
          } else {
            setFormMsg('تم إرسال تقييمك — سيُراجع قبل النشر.', false);
          }
          loadReviews(false);
          return fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate');
        });
      })
      .then(function (data) {
        if (data && data.aggregate) renderAggregate(data.aggregate);
      })
      .catch(function (err) {
        if (err.status === 401 || (err.payload && err.payload.error === 'login_required')) {
          showLoginGate();
          return;
        }
        if (err.payload && err.payload.error === 'rate_limited') {
          setFormMsg('محاولات كثيرة — حاولي لاحقاً.', true);
          return;
        }
        setFormMsg('تعذّر إرسال التقييم. حاولي مرة أخرى.', true);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function bootList() {
    if (started) return;
    started = true;
    var ssrEl = document.getElementById('eros-reviews-ssr');
    if (ssrEl) ssrEl.hidden = true;
    fetchJson('/api/v1/products/' + encodeURIComponent(handle) + '/aggregate')
      .then(function (data) {
        renderAggregate(data.aggregate);
        loadReviews(false);
      })
      .catch(function () {
        loadReviews(false);
      });
  }

  function initForm() {
    ensureLightbox();
    ensureSortBar();
    buildStarInput();
    if (form) form.addEventListener('submit', submitReview);
    if (listEl) {
      listEl.addEventListener('click', onListClick);
      listEl.addEventListener('submit', onListSubmit);
    }
    var loginBtn = document.getElementById('eros-reviews-login-btn');
    if (loginBtn && loginUrl) loginBtn.href = loginUrl;

    if (photoInput) {
      photoInput.addEventListener('change', function () {
        pendingPhotoFile = photoInput.files && photoInput.files[0] ? photoInput.files[0] : null;
        if (photoNameEl) {
          if (pendingPhotoFile) {
            photoNameEl.textContent = pendingPhotoFile.name;
            photoNameEl.hidden = false;
          } else {
            photoNameEl.textContent = '';
            photoNameEl.hidden = true;
          }
        }
      });
    }

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('review') === '1') {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (bodyEl) bodyEl.focus();
      }
    } catch (e) {}
  }

  initForm();

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.disconnect();
            bootList();
          }
        });
      },
      { rootMargin: '200px' },
    );
    io.observe(root);
  } else {
    bootList();
  }
})();
